// Loosely based on parts of - react-scroll-to
// https://github.com/ganderzz/react-scroll-to
// MIT License

import React, { isValidElement, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import * as scrollActions from '../../../Data/ReduxViewModels/GridScrollLink/actions';
import deepEquals from '../../../Lib/Object/deepEquals';

let counter = 0;

const ScrollArea = ({ scrollLinkId, children, className, position = undefined }) => {
  const dispatch = useDispatch();
  const [id] = useState(counter++);
  const gridScrollLink = useSelector((s) => s.gridScrollLink, deepEquals);
  const node = React.createRef();

  useEffect(() => {
    if (scrollLinkId) {
      dispatch(scrollActions.initialiseGridScrollLink(scrollLinkId, node.current.scrollLeft));
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    return () => {
      if (scrollLinkId) {
        dispatch(scrollActions.cleanupGridScrollLink(scrollLinkId));
      }
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const setScrollPosition = (position) => {
      _scrollNode(node.current, position);
    };

    // Only change position if it has actually been changed. Prevents us unnecessarily changing position
    // on first render when lastChangedBy is still undefined.
    if (gridScrollLink.lastChangedBy !== undefined && id !== gridScrollLink.lastChangedBy && scrollLinkId) {
      setScrollPosition(gridScrollLink[scrollLinkId]);
    }
  }, [gridScrollLink, scrollLinkId, id, node]);

  const handleScroll = (e) => {
    // Only update position if the scroll left value has changed
    if (
      scrollLinkId &&
      id === gridScrollLink.lastChangedBy &&
      gridScrollLink[scrollLinkId] !== node.current.scrollLeft
    ) {
      dispatch(scrollActions.setGridScrollLinkPosition(id, scrollLinkId, node.current.scrollLeft));
    }
  };

  // To prevent unnecessary rendering AND prevent behaviour where the scroll bar flickers back and forth, we set the
  // changed by when 'clicking' the scroll bar such that we know which scroll area is the 'master' during scrolling.
  // Then we only change the others to match and don't let them attempt to change the value in the state.
  const setSelectedScroll = () => {
    if (scrollLinkId && id !== gridScrollLink.lastChangedBy)
      dispatch(scrollActions.setGridScrollLinkPosition(id, scrollLinkId, node.current.scrollLeft));
  };

  const _scrollNode = (node, val) => {
    if (!node) {
      return;
    }
    if (isValidElement(node)) {
      const rNode = ReactDOM.findDOMNode(node);

      if (rNode) {
        node = rNode;
      }
    }
    if (node.scrollTo) {
      node.scrollLeft = val;
    }
  };

  return (
    <div
      className={className}
      id={id}
      position={position}
      ref={node}
      onMouseDown={() => setSelectedScroll()}
      onScroll={(e) => handleScroll(e)}
    >
      {children}
    </div>
  );
};

export { ScrollArea };
export default ScrollArea;
